module.exports = __webpack_public_path__ + "assets/lessons/pl/lesson7/modals/lesson_7_3_a.pdf";